enum AccessibilityMode {
  PublicOnly = 0,
  AdminOnly = 1,
  Both = 2
}

export default AccessibilityMode;
